import GiftIcon from "../../assets/GiftIcon.png";

export default function ListPreviewCollage({ items = [] }) {
    const placeholder = "https://placehold.co/80x80?text=No+Image";

    // Take first 9 items, use imageUrl or fallback
    const images = items.slice(0, 9).map((item) => item.imageUrl || placeholder);

    // If no items, show default GiftIcon
    if (images.length === 0) {
        return (
            <div className="w-full h-full flex items-center justify-center bg-surface">
                <img src={GiftIcon} alt="No items" className="w-3/4" />
            </div>
        );
    }

    return (
        <div className="relative w-full h-full overflow-hidden rounded-lg bg-white">
            <div
                className="absolute grid gap-[1px]"
                style={{
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%) rotate(45deg) scale(3)",
                    transformOrigin: "center",
                    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
                }}
            >
                {images.map((url, index) => (
                    <div key={index} className="overflow-hidden rounded-sm">
                        <img
                            src={url}
                            alt={`Item ${index + 1}`}
                            className="w-full h-full object-cover transition-transform duration-300"
                        />
                    </div>
                ))}
            </div>
        </div>
    );
}
